import React, {Component} from "react";
import promoterValidator from "../../../helpers/promoterValidator";
import CommonValidator from "../../../helpers/CommonValidator";
import PromoterSectionList from "../PromoterSection/PromoterSectionList";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import DeleteModal from "../../Common/Modal/DeleteModal";
import PromoterSectionModal from "../PromoterSection/PromoterSectionModal";
import {I18n} from "../../../I18n/components/promoter";
import {
    fetchPromoterSections,
    removePromoterSection,
    saveNewPromoterSection,
    updateSinglePromoterSection
} from "../../../actions/promoter/promoterSectionActions";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {SUPER_ADMIN, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {fetchPromoterCategories} from "../../../actions/promoter/promoterCategoryActions";
import PromoterSectionControls from "./PromoterSectionControls";
import swal from "sweetalert";
import {isPromoterPermission} from "../../../helpers/companyService";

class PromoterSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeSectionId: null,
            newSection: {
                id: null,
                name: '',
                companyId: null,
                categoryId: null,
                showPriceTag: false,
            },
            companyIdFilter: '',
            categoryIdFilter: '',
            currentPage: 0,
            modal: false,
            isSaveDisable: false,
        };
        this.validators = promoterValidator(props.lang).sectionValidator;
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority, location} = this.props;

            if (!isPromoterPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            const companyId = authority !== SUPER_ADMIN
                ? company.id
                : null;
            await this.props.fetchCategories({companyId});
            await this.fetchPaginatedData(0);
            if (location.state && location.state.modal)
                await this.toggle();
        })();
    }

    isConflictError = response => response && response.status === 409;

    fetchPaginatedData = async currentPage => {
        const {company, authority} = this.props;
        const {companyIdFilter, categoryIdFilter} = this.state;
        await this.props.fetchSections({
            companyId: authority === SUPER_ADMIN ? companyIdFilter : company.id,
            categoryId: categoryIdFilter,
            page: currentPage
        });
        await this.setState({
            currentPage
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    toggle = async () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    isOkModalToggle = id => {
        this.setState({
            isOkModal: !this.state.isOkModal,
            activeSectionId: id
        });
    };

    onCompanyFilterClick = event => {
        this.setState({
            companyIdFilter: event.target.value,
            categoryIdFilter: ''
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    onCategoryFilterClick = event => {
        this.setState({
            categoryIdFilter: event.target.value
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    clearFilters = () => {
        this.setState({
            companyIdFilter: '',
            categoryIdFilter: '',
        }, () => {
            this.fetchPaginatedData(0);
        })
    };

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value;
        this.commonValidator.checkField(name, value);
        this.setState(state => ({
            newSection: Object.keys(state.newSection).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.newSection[key];
                }
                return res
            }, {})
        }));
    };

    clearNewSectionState = async () => {
        this.commonValidator.resetAllErrors();
        await this.setState({
            newSection: {
                id: null,
                name: '',
                companyId: null,
                categoryId: null,
                showPriceTag: false,
            },
            activeSectionId: null,
        });
    };

    addCategoryClick = () => {
        this.props.changeLocation({
            pathname: '/dashboard/promoter/categories',
            state: {
                modal: true
            }
        })
    }

    addSectionClick = async () => {
        await this.clearNewSectionState();
        await this.toggle();
    };

    onEditSection = async (id) => {
        const {promoterCategories, promoterSections} = this.props;
        await this.clearNewSectionState();
        let selectedSection = promoterSections
            .find(item => item.id === id);
        const category = promoterCategories
            .find(category => category.id === selectedSection.categoryId);
        this.setState({
            modal: !this.state.modal,
            newSection: {
                ...selectedSection,
                companyId: category.companyId
            },
        });
    };

    deleteSection = async () => {
        await this.props.deleteSection(this.state.activeSectionId);
        await this.fetchPaginatedData(0);
        this.setState({
            activeSectionId: null
        }, () => this.isOkModalToggle(null))
    };

    handleSubmit = async (event) => {
        const {newSection} = this.state;
        const {lang, promoterSections} = this.props;
        if (event) {
            event.preventDefault();
        }
        let sections = promoterSections || [];
        if (this.commonValidator.isValid()) {
            await this.setState({isSaveDisable: true});
            const sectionExists = sections.filter(section => section.id === newSection.id)
                .length > 0;
            const promise = sectionExists
                ? this.props.updateSection(newSection)
                : this.props.saveSection(newSection);
            promise.then(async () => {
                await this.fetchPaginatedData(0);
                await this.clearNewSectionState();
                await this.toggle();
            }, error => {
                if (this.isConflictError(error)) {
                    swal(I18n[lang].sectionAlreadyExists, "", "error")
                }
                console.log(error.statusText);
            })
            await this.setState({isSaveDisable: false});
        }
    };

    render() {
        const {
            lang,
            authority,
            companies,
            loading,
            promoterCategories,
            promoterSections,
            pagination
        } = this.props;
        const {currentPage, isOkModal, newSection, modal, companyIdFilter, categoryIdFilter} = this.state;
        const promoterSectionList = loading
            ? <div className="loading">Loading...</div>
            : <PromoterSectionList
                lang={lang}
                companies={companies}
                categories={promoterCategories}
                sections={promoterSections}
                currentPage={currentPage}
                onEditSection={this.onEditSection}
                isOkModalToggle={this.isOkModalToggle}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
            />

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <DeleteModal
                    lang={lang}
                    isOkModal={isOkModal}
                    toggle={this.isOkModalToggle}
                    onDeleteClick={this.deleteSection}
                />
                <PromoterSectionModal
                    lang={lang}
                    isModal={modal}
                    toggle={this.toggle}
                    newSection={newSection}
                    companies={companies}
                    categories={promoterCategories}
                    handleSubmit={this.handleSubmit}
                    onInputChange={this.onInputChange}
                    validator={this.commonValidator}
                    isSaveDisable={this.state.isSaveDisable}
                    authority={authority}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-play-circle-outline mr-2"/>
                            {I18n.promoterTitleBeginning + I18n[lang].sections}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <PromoterSectionControls
                            lang={lang}
                            onCompanyFilterClick={this.onCompanyFilterClick}
                            onCategoryFilterClick={this.onCategoryFilterClick}
                            authority={authority}
                            companies={companies}
                            companyId={companyIdFilter}
                            categories={promoterCategories}
                            categoryId={categoryIdFilter}
                            clearFilters={this.clearFilters}
                            addCategoryClick={this.addCategoryClick}
                            addSectionClick={this.addSectionClick}
                        />
                        {promoterSectionList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchCategories: query => dispatch(fetchPromoterCategories(query)),
        fetchSections: query => dispatch(fetchPromoterSections(query)),
        updateSection: section => dispatch(updateSinglePromoterSection(section)),
        saveSection: section => dispatch(saveNewPromoterSection(section)),
        deleteSection: sectionId => dispatch(removePromoterSection(sectionId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    promoterCategories: state.promoterCategories.promoterCategories,
    promoterSections: state.promoterSections.promoterSections,
    pagination: state.promoterSections.pagination,
    loading: state.promoterSections.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterSection);


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSection/PromoterSection.js